import { Button, Dialog, DialogActions, DialogContent, DialogTitle } from '@mui/material';

import type { LicensedPeriodDPH, MonthlyDPH } from '@/types';

import { MonthlyUsageBarChart } from './MonthlyUsageBarChart';

interface HistoryModalProps {
  isOpen: boolean;
  setIsOpen: (open: boolean) => void;
  data: {
    licensedPeriodDPH: LicensedPeriodDPH;
    monthlyDPH: MonthlyDPH;
  };
}

/**
 * Modal displaying monthly DPH usage history as a bar chart
 * Read-only view showing all historical months
 */
export const HistoryModal = ({ isOpen, setIsOpen, data }: HistoryModalProps) => {
  const handleClose = () => {
    setIsOpen(false);
  };

  // Prevent closing on backdrop click or escape key
  const handleDialogClose = (_event: object, reason: string) => {
    if (reason === 'backdropClick' || reason === 'escapeKeyDown') {
      return;
    }
    handleClose();
  };

  return (
    <Dialog
      open={isOpen}
      onClose={handleDialogClose}
      maxWidth="lg"
      fullWidth
      disableEnforceFocus
      disableEscapeKeyDown
    >
      <DialogTitle>
        <strong>DPH History</strong>
      </DialogTitle>

      <DialogContent>
        <MonthlyUsageBarChart
          monthlyDPH={data.monthlyDPH}
          licensedPeriodDPH={data.licensedPeriodDPH}
        />
      </DialogContent>

      <DialogActions>
        <Button onClick={handleClose}>Close</Button>
      </DialogActions>
    </Dialog>
  );
};
